import React, { Component } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import i18next from 'i18next';
import { Input, Button } from 'antd';
import Breadcremb from '../../../components/BreadCremb';
import axios from 'axios';
import Swal from 'sweetalert2';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import locationnew from '../../../assets/images/icons/locationnew.svg'
import calendar from '../../../assets/images/icons/calendar.svg'

const { TextArea } = Input;


class BusinessViewPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            business: null,
            loading: true,
            chatId: null, // To store the chat ID if it exists or after creation
            currentUserId: null, // To store the logged-in user's ID
        };
        this.mainSlider = React.createRef();
        this.navSlider = React.createRef();
    }

    // Method to fetch business details based on booking_id
    fetchBusinessDetails = async () => {
        const { booking_id } = this.props.match.params;  // Capture the booking_id from the URL

        try {
            this.setState({ loading: true });  // Set loading to true while fetching data
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/businessdetails/${booking_id}`);
            const data = await response.json();
            this.setState({ business: data, loading: false });  // Store the fetched data in state and set loading to false
        } catch (error) {
            console.error("Error fetching business details:", error);
            this.setState({ loading: false });  // Set loading to false after fetching
        }
    };

    // Method to navigate back
    getToBack = () => {
        this.props.history.goBack();
    };

    componentDidMount() {
        console.log('did mount enters')
        const user_info = JSON.parse(localStorage.getItem('user'));
        console.log('useri',user_info);
        if(!user_info){
            this.props.history.push('/user/user-login'); // Redirect to the previous page
            return;
        }
        this.setState({ currentUserId: user_info.user_id }, () => {
            this.fetchBusinessDetails();  // Fetch the business details when the component mounts
        });
    }

    get_chats = (chat_id) => {
        console.log('CHATTY', chat_id);
        var obj = {};
        obj.chat_id = chat_id;
        this.props.history.push('/chat', obj);
    }

    get_pro_chat = () => {
        const { business } = this.state;
        console.log('BUSY', business);
        const user_info = JSON.parse(localStorage.getItem('user'));
        console.log('user_info', user_info);

        if (!this.state.chatId) {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            const params = new URLSearchParams();
            params.append('user_id', user_info.user_id);
            params.append('booking_id', business._id);
            params.append('post_user_id', business.userId);

            axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/businesscreatechat`, params, config)
                .then((res) => {
                    console.log('RESIE', res);
                    if (res.data.status_code === 200) {
                        this.get_chats(res.data.chat_id);
                        business.chat_id = res.data.chat_id;
                        this.setState({
                            business: business
                        });
                    } else if (res.data.status_code === 401) {
                        console.log('RESO', res);

                        // Handle unauthorized access (e.g., user is not logged in)
                        Swal.fire({
                            title: i18next.t('Error'),
                            text: i18next.t('You need to log in first.'),
                            icon: 'error',
                        });
                        // Redirect to login or handle accordingly
                    }
                    else if (res.data.status_code === 404) {
                        Swal.fire({
                            title: i18next.t('Error'),
                            text: i18next.t('No business for sale records found.'),
                            icon: 'error',
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error creating chat:", error);
                    Swal.fire({
                        title: i18next.t('Error'),
                        text: i18next.t('Failed to create chat. Please try again later.'),
                        icon: 'error',
                    });
                });
        } else {
            // If chatId exists, simply redirect to chat page or show chat
            Swal.fire({
                title: i18next.t('Chat'),
                text: i18next.t('You already have a chat with the seller.'),
                icon: 'info',
            });
        }
    };
    handleSlideChange = (index) => {
        this.setState({ activeIndex: index });
    };
    render() {
        const { business, loading, currentUserId } = this.state;

        // if (loading) {
        //     return <div>Loading...</div>;  // Show loading message while fetching data
        // }

        // if (!business) {
        //     return <div>No business found</div>;  // Handle the case where no business data is found
        // }
console.log('currentuserid', currentUserId);
console.log('busineid', business);
        // Check if the current user is the owner of the business post
        // const isOwnPost = currentUserId === business.new_user;
        const isOwnPost = business ? currentUserId === business.new_user : false;


        // const settings = {
        //     dots: true,
        //     customPaging: (i) => (
        //         <img
        //             src={`http://services.hitasoft.in/juan/public/img/bookings/${images[i]}`}
        //             alt={`Thumbnail ${i + 1}`}
        //             className='paging_thumb'
        //         />
        //     ),
        //     dotsClass: "slick-dots slick-thumb",
        //     infinite: true,
        //     speed: 500,
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     beforeChange: (oldIndex, newIndex) => this.handleSlideChange(newIndex),
        // };

        const settingsMain = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            infinite: false,
            swipeToSlide: true,
            asNavFor: this.navSlider.current, // Use ref directly
          };
      
          const settingsNav = {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: this.mainSlider.current, // Use ref directly
            focusOnSelect: true,
            swipeToSlide: true,
            // centerMode: true,
          };

        return (
            <div className="container">
            <div className="business-view">
                    <div className='breadcrumbs_Div'>
                        <div>
                            <Breadcremb flag="others" bredcrumb1_link="/tasker" bredcrumb1="Home" bredcrumb2="Details Page" />
                            <h1>{i18next.t('Business Details')}</h1>

                        </div>                
                <div className="d-flex align-items-center hover-cont back_div" onClick={this.getToBack}>
                    <ArrowLeftOutlined />
                    <span>{i18next.t("Back")}</span>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                    <div className="slider-container">

                    <Slider {...settingsMain} ref={this.mainSlider} className='pagin_slider'>
                                    {business?.images.map((image, index) => (
                                        <div key={index} className="main-image slidernav-image">
                                            <img
                                                src={`https://emprende.net/public/img/bookings/${image}`}
                                                // src={`http://services.hitasoft.in/juan/public/img/bookings/${image}`}
                                                // src={`${image}`}
                                                alt={`Business Image ${index}`}
                                            />
                                        </div>
                                    ))}
                                </Slider>

                                {/* Thumbnail Navigation Slider */}
                                <Slider {...settingsNav} ref={this.navSlider} className='paging_thumb'>
                                    {business?.images.map((image, index) => (
                                        <div key={index} className="main-image">
                                            <img
                                                // src={`http://services.hitasoft.in/juan/public/img/bookings/${image}`}
                                                src={`https://emprende.net/public/img/bookings/${image}`}

                                                alt={`Business Image ${index}`}
                                                className='paging_thumb'
                                            />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                    </div>

                    <div className="col-md-6">
                        {/* Form Section */}
                        <div className="business-details business_details_page">
                            {/* <h1>{i18next.t('Business Details')}</h1> */}

                            {/* Business Title */}
                            <p className="mb-3 fM">{i18next.t('Title')}</p>
                            <div className="mb-3">
                                <Input size="large" value={business?.bookedName} readOnly />
                            </div>

                            {/* Main Category */}
                            <p className="mb-3 fM">{i18next.t('Main Category')}</p>
                            <div className="mb-3">
                                <Input size="large" value={business?.mainCategory?.name} readOnly />
                            </div>

                            {/* Sub Category */}
                            <p className="mb-3 fM">{i18next.t('Sub Category')}</p>
                            <div className="mb-3">
                                <Input size="large" value={business?.subCategory?.name} readOnly />
                            </div>

                            <p className="mb-3 fM">{i18next.t('Country')}</p>
                            <div className="mb-3 countrydiv">
                                <img src={locationnew} />
                                <Input size="large" value={business?.country} readOnly />
                            </div>
                           
                            <p className="mb-3 fM">{i18next.t('City')}</p>
                            <div className="mb-3 countrydiv">
                                <img src={locationnew} />
                                <Input size="large" value={business?.city} readOnly />
                            </div>

                            <p className="mb-3 fM">{i18next.t('Sale Price')}</p>
                            <div className="mb-3">
                                <Input size="large" value={Math.floor(business?.new_price)?.toLocaleString('en-US')} readOnly />
                            </div>

                            {/* Booked When */}
                            <p className="mb-3 fM">{i18next.t('Start date')}</p>
                            <div className="mb-3 countrydiv">
                            <img src={calendar} />
                                <Input size="large" value={new Date(business?.bookedWhen).toLocaleDateString()} readOnly />
                            </div>

                             <p className="mb-3 fM">{ i18next.t("Description") }</p>
                             <div className="mb-3">
                            <TextArea 
                                value={ business?.bookedFor } style={{ height: '200px' }} readOnly
                            />
                            </div>



                            {/* Conditionally render the "Chat with Seller" button */}
                            {!isOwnPost && (
                                <div className="chat-button chat_btns mt-4">
                                    <Button type="primary" onClick={this.get_pro_chat}>
                                        {i18next.t('Chat with Seller')}
                                    </Button>
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BusinessViewPage;